class GravityForms {

    constructor() {
        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if (params && params.gclid){
            setCookie('gclid', params.gclid, 7);
        }
        
        if (params && params.li_fat_id){
            setCookie('li_fat_id', params.li_fat_id, 7);
        }

        var gclid = getCookie('gclid');
        if (!gclid){
            gclid = "";
        }
        document.querySelectorAll('.gform_hidden[value="{gclid}"]').forEach(ele => {
            ele.value = gclid;
        })

        var li_fat_id = getCookie('li_fat_id');
        if (!li_fat_id){
            li_fat_id = "";
        }
        document.querySelectorAll('.gform_hidden[value="{li_fat_id}"]').forEach(ele => {
            ele.value = li_fat_id;
        })
    }
};

export default new GravityForms;
